import { formatSignedHundredths } from '@optiflow/shared';
import type { FrameDetails, PrescriptionLensDetails, SupportedLocale } from '@optiflow/types';
import { formatDate } from '@/utils/format';

/** A calendar date as written on a prescription, shown without shifting it through a timezone. */
export function formatCalendarDate(value: string, locale: SupportedLocale): string {
  return formatDate(new Date(`${value}T12:00:00Z`), locale);
}

/** A frame's sizes as opticians write them: lens width, bridge and temple, 52□18 140. */
export function frameSizes(details: FrameDetails | null): string | null {
  if (!details) return null;
  const { lensWidthMm, bridgeWidthMm, templeLengthMm } = details;
  if (lensWidthMm === null && bridgeWidthMm === null && templeLengthMm === null) return null;
  return `${lensWidthMm ?? '–'}□${bridgeWidthMm ?? '–'} ${templeLengthMm ?? '–'}`;
}

/** Dioptres from the catalogue, for display only, with their sign and two decimals. */
const power = (value: number | null) =>
  value === null ? '…' : formatSignedHundredths(Math.round(value * 100));

/** The range a lens can be made in, as its catalogue states it. Guidance to choose by; the server decides. */
export function lensRange(details: PrescriptionLensDetails): string {
  const parts = [`SPH ${power(details.sphereMin)} / ${power(details.sphereMax)}`];
  if (details.cylinderMin !== null || details.cylinderMax !== null) {
    parts.push(`CYL ${power(details.cylinderMin)} / ${power(details.cylinderMax)}`);
  }
  if (details.additionMin !== null || details.additionMax !== null) {
    parts.push(`ADD ${power(details.additionMin)} / ${power(details.additionMax)}`);
  }
  return parts.join(' · ');
}
